const MenuModifiers = () => import(/* webpackChunkName: "itemAvailabilities" */ '@/components/menueditor/menuModifiers')


export default {
    name: 'menuModifiers',
    path: 'menueditor/menuModifiers',
    redirect: '/menueditor/menuModifiers/index',
    meta: {label: 'menuModifiers'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: [0, 1, 2, 3, 4, 5, 6, 7]},
            component: MenuModifiers,
            props: true
        }
    ]
}
